"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = parseFloat;
function parseFloat(value) {
    return !value || typeof value !== 'string' || Number.isNaN(+value)
        ? value
        : +value;
}
